<template>
  <div style="width: 100%; height: 100%">
    <loader v-if="loading"></loader>
    <modal-form
      v-if="dialog"
      :title="selectedMarker.title"
      :show="dialog"
      @update:show="dialog=$event"
      save-action-caption="Details"
      cancel-action-caption="Close"
      v-on:saveData="openDetails"
    ></modal-form>
    <GmapMap
      ref="mapRef"
      :center="{
        lat:45.3752626,
        lng:17.8305981
      }"
      :zoom="8"
      map-type-id="terrain"
      style="width: 100%; height: 100%"
    >
      <gmap-cluster :zoomOnClick="true">
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :title="m.title"
          :position="m.location"
          :clickable="true"
          @click="clicked(m)"
        />
      </gmap-cluster>
    </GmapMap>
  </div>
</template>

<script>
  import { gmapApi } from 'vue2-google-maps'
  import GmapCluster from 'vue2-google-maps/dist/components/cluster'
  import SitesService from '@/services/sites'
  import Loader from '@/components/Loader'
  import ModalForm from '@/components/ModalForm'

  export default {
    name: 'Index',
    components: {
      ModalForm,
      Loader,
      GmapCluster,
    },
    computed: {
      google: gmapApi,
    },
    data: () => ({
      markers: [],
      loading: false,
      dialog: false,
      selectedMarker: undefined,
    }),
    mounted () {
      this.loading = true
      this.$refs.mapRef.$mapPromise.then((map) => {
        setTimeout(() => {
          this.loadMarkers()
        }, 100)
      })
    },
    methods: {
      loadMarkers () {
        const ss = new SitesService()
        ss.forMap().then((response) => {
          for (const site of response.data.data) {
            this.markers.push({
              title: site.site_id + ' ' + site.site_name,
              id: site.id,
              location: new this.google.maps.LatLng(site.latitude, site.longitude),
            })
          }
          this.loading = false
        })
      },
      clicked (marker) {
        this.selectedMarker = marker
        this.dialog = true
      },
      openDetails () {
        this.$router.push({ path: `/sites/${this.selectedMarker.id}/view` })
      },
    },
  }
</script>

<style scoped>

</style>
